import { defa, T } from 'defa-object';
import View        from 'scripts/poppet/view';
import template    from 'templates/logEntryView.jst.html';

/**
 * defa.views.LogEntryView
 * A view presenting a single LogEntry.
 * @version 1.2.0
 */

const LogEntryView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: function () {
		return ( this.model.get( 'fresh' ) )
			   ? 'log-entry new'
			   : 'log-entry';
	},
	
	behaviors: {
		ExpandSpoiler: {},
	},
	
	templateContext: function () {
		return {
			translatedTags: this.getTranslatedTags(),
			taggedOn      : this.getTaggedOn(),
			date          : this.getDate(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view is attached to the DOM.
	 * @void
	 */
	onAttach: function () {
		let self = this;
		
		setTimeout( function () {
			self.$el.removeClass( 'new' );
		}, 3000 );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets a comma-separated list of what the log-post is tagged on.
	 * @return {string}  A comma-separated list of which data models this log-post is tagged on.
	 */
	getTaggedOn: function () {
		let arr = [];
		
		if ( this.model.get( 'user' ) ) {
			arr.push( 'user: ' + this.model.get( 'user' ) );
		}
		
		if ( this.model.get( 'unit' ) ) {
			arr.push( 'unit: ' + this.model.get( 'unit' ) );
		}
		
		if ( this.model.get( 'customer' ) ) {
			arr.push( 'customer: ' + this.model.get( 'customer' ) );
		}
		
		return arr.join( ', ' );
	},
	
	/**
	 * Gets a i18n-formated human readable date for when the post was made.
	 * @return {string}  A human readable date.
	 */
	getDate: function () {
		let date = new Date( this.model.get( 'timestamp' ) );
		
		return date.format( T.dateFormatLong );
	},
	
	/**
	 * Gets translated tag names in a list.
	 * @return {string}  A list of translated tag names.
	 */
	getTranslatedTags: function () {
		
		let arr = _.map( this.model.get( 'tags' ), function ( tag ) {
			return _.where( defa.vars.logTags, { value: tag } )[ 0 ].term;
		} );
		
		return arr.join( ', ' );
	},
	
} );

export default LogEntryView;